import {
  Button,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import chevronDown from "../../assets/images/chevronDown.svg";
import chevronUp from "../../assets/images/chevronUp.svg";
import "./moreactionmenu.scss";
import infoIcon from "../../assets/images/info.svg";
import editIcon from "../../assets/images/edit.svg";
import deleteIcon from "../../assets/images/delete.svg";
import ellipseIcon from "../../assets/images/ellipse.svg";
import TestPersonInfo from "./testPersonInfo/TestPersonInfo";
import RemoveSenior from "../modals/RemoveSenior";
import RemoveSuccess from "../modals/RemoveSuccess";
import { handleParams, isProd, searchParams } from "../../utlis/helpers";
import { Link, useNavigate } from "react-router-dom";
import { TEST_HISTORY } from "../../routes/routerPath";
import testHistoryIcon from "../../assets/images/testHistory.svg";
import { pageLocale } from "../../utlis/locale";

const MoreActionMenu = ({ userInfo }) => {
  const [open, setOpen] = useState(false);
  const [openTestPerson, setOpenTestPerson] = useState(false);
  const [removeSeniorModal, setRemoveSeniorModal] = useState(false);
  const [removePopUp, setRemovePopup] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const {
    more_action,
    test_history,
    test_person_info,
    edit_info,
    remove_person,
  } = pageLocale("testModule");
  const navigate = useNavigate();
  const editTestPersonHandler = () => {
    sessionStorage.clear("userList");
  };

  const testHistoryHandler = () => {
    navigate(TEST_HISTORY + `${searchParams}`);
  };

  return (
    <>
      <div className="more-action-wrapper">
        <Button
          ref={anchorRef}
          className="more-action-button"
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          endIcon={
            !open ? (
              <img src={chevronDown} className="end-icon" />
            ) : (
              <img src={chevronUp} className="end-icon" />
            )
          }
        >
          <img
            src={ellipseIcon}
            alt="more-action"
            className="mobile-view-more-action-btn"
          />

          <Typography className="more-action-text">{more_action}</Typography>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          className="more-action-dropdown-block"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper className="more-action-dropdown-wrapper">
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    className="more-action-menulist-block"
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                  >
                    <MenuItem
                      className="menu-item"
                      onClick={() => setOpenTestPerson(true)}
                    >
                      <img src={infoIcon} alt="info" className="icon" />
                      {test_person_info}
                    </MenuItem>
                    <MenuItem
                      className="menu-item"
                      onClick={() => testHistoryHandler(true)}
                    >
                      <img src={testHistoryIcon} alt="info" className="icon" />
                      {test_history}
                    </MenuItem>

                    <Link
                      to={`${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/edit-test-person${handleParams()}&seniorUuid=${userInfo?.id}&showHeader=true&gobackWebsite=true`}
                      // to={`${isProd ? `https://testpersons.seniorlife.io` : `https://testpersons.dev.seniorlife.io`}/edit-test-person/?seniorUuid=${userInfo?.id}&staffId=${storedTest?.id}&showHeader=true&locale=${locale}&accessToken=${accessToken}&gobackWebsite=true`}
                      className="link-item"
                    >
                      <MenuItem
                        className="menu-item"
                        onClick={editTestPersonHandler}
                      >
                        <img src={editIcon} alt="edit" className="icon" />
                        {edit_info}
                      </MenuItem>
                    </Link>
                    <MenuItem
                      onClick={() => setRemoveSeniorModal(true)}
                      className="menu-item"
                    >
                      <img src={deleteIcon} alt="delete" className="icon" />
                      {remove_person}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
      {openTestPerson && (
        <TestPersonInfo
          openTestPerson={openTestPerson}
          setOpenTestPerson={setOpenTestPerson}
        />
      )}
      {removeSeniorModal && (
        <RemoveSenior
          removeSeniorModal={removeSeniorModal}
          setRemoveSeniorModal={setRemoveSeniorModal}
          setRemovePopup={setRemovePopup}
          userInfo={userInfo}
        />
      )}
      <RemoveSuccess
        removePopUp={removePopUp}
        setRemovePopup={setRemovePopup}
        userInfo={userInfo}
      />
    </>
  );
};

export default MoreActionMenu;
